// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles-module__avatar___1163Y","avatars":"styles-module__avatars___2Cqf7"};